import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('intelligentQueryStore')
@observer
class TerminologyConfig extends Component {
  render() {
    const { intelligentQueryStore, location } = this.props
    const { isFetching } = intelligentQueryStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm location={location} />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default TerminologyConfig;